var render = function render(){var _vm=this,_c=_vm._self._c;return _c('veui-dialog',{attrs:{"ui":"auto","title":_vm.title,"open":_vm.show,"footless":true,"overlay-class":"upload-dialog"},on:{"cancel":_vm.close}},[_c('div',{staticClass:"content"},[_c('fileUpload',{attrs:{"type":_vm.type},on:{"addCase":_vm.addCase,"addQa":_vm.addQa}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }